<template>
  <el-dialog
    class="venueAppointment-edit"
    title="修改场馆预约信息"
    :visible="dialogFormVisible"
    width="850px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <el-descriptions
      class="margin-top"
      title=""
      :column="2"
      border
      direction="horizontal"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building"></i>
          选择场馆
        </template>
        <el-select
          v-model="venueData.name"
          placeholder="请选择"
          @change="selectChange"
        >
          <el-option
            v-for="item in publicvenueList"
            :key="item.id"
            :label="item.venueName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          使用时间
        </template>
        <el-date-picker
          v-model="dateTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="margin-top"
      title=""
      :column="1"
      border
      direction="vertical"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          预约原因
        </template>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="venueData.reasonRemark"
        >
        </el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    venueAppointmentData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    publicvenueList: {
      type: Array,
    },
  },
  data() {
    return {
      statusList: [
        {
          label: "正常",
          value: "0",
        },
        {
          label: "停用",
          value: "1",
        },
      ],
      dateTime: "",
      venueData: {
        name: "",
        id: "",
        reasonRemark: ""
      },
    };
  },
  methods: {
    selectChange(e) {
      this.venueData.id = e;
    },
    dialogOpen() {
      console.log(this.venueAppointmentData);
      this.venueData.name = this.venueAppointmentData.venueName;
      this.venueData.id = this.venueAppointmentData.venueId;
      this.venueData.reasonRemark = this.venueAppointmentData.request.reasonRemark;
      this.dateTime = [
        this.venueAppointmentData.startTime,
        this.venueAppointmentData.endTime,
      ];
    },
    dialogClose() {
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      let { requestCode, id } = this.venueAppointmentData;
      let data = {
        requestCode,
        id,
        schoolId: this.user.schoolId,
        venueId: this.venueData.id,
        teacherId: this.user.id,
        startTime: this.dateTime[0],
        endTime: this.dateTime[1],
        reasonRemark: this.venueData.reasonRemark
      };
      this.put(this.$url.editVenueappointment, data).then((res) => {
        // console.log("修改场馆返回==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        // 刷新列表
        this.$emit("edit", requestCode);
        // 关闭弹出框
        this.dialogClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./venueAppointmentEdit.scss";
</style>